import { render, staticRenderFns } from "./TypesOfService.vue?vue&type=template&id=28508ef6&scoped=true&"
import script from "./TypesOfService.vue?vue&type=script&lang=js&"
export * from "./TypesOfService.vue?vue&type=script&lang=js&"
import style0 from "./TypesOfService.vue?vue&type=style&index=0&id=28508ef6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28508ef6",
  null
  
)

export default component.exports